module.exports = __webpack_public_path__ + "img/image-empty.966165cb.svg";